const headerPaymentMethod = ['Country Name', 'Payment Method Name', 'Action'];

export default headerPaymentMethod;
